import React from 'react'
import PropTypes from 'prop-types'

const PlusCircleIcon = ({
  size = '24',
  color = '#101820',
  strokeWidth = '2.5',
  fillColor = 'none',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2996 12.8794H8.3656"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M12.8326 17.2724L12.8326 8.48621"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M12.8325 23.8621C19.0002 23.8621 24 18.945 24 12.8794C24 6.81376 19.0002 1.89661 12.8325 1.89661C6.66493 1.89661 1.6651 6.81376 1.6651 12.8794C1.6651 18.945 6.66493 23.8621 12.8325 23.8621Z"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}

export default React.memo(PlusCircleIcon)

PlusCircleIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  fillColor: PropTypes.string,
  strokeWidth: PropTypes.string,
}
